var path = '/pages/guestlists/views/pages/rsvps/details/checkins.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n\n<al-rsvp-checkins ng-if=\"!vm.loading\" rsvp=\"vm.rsvp\"></al-rsvp-checkins>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/details/checkins.tpl.html
// module id = 2278
// module chunks = 1